/*
openbikebox Frontend
Copyright (C) 2021 binary butterfly GmbH

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU General Public License as published by
the Free Software Foundation, either version 3 of the License, or
(at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU General Public License for more details.

You should have received a copy of the GNU General Public License
along with this program.  If not, see <http://www.gnu.org/licenses/>.
*/

import {requestGet, requestAdminAjaxPost} from "./Helpers";


export const getLocations = (base_url) => {
    return requestGet(base_url + '/api/public/v1/locations');
}

export const getLocationsGeoJSON = (base_url, operatorId) => {
    let path = '/api/public/v1/locations/geojson';
    if (operatorId) {
        path += '?operator_id=' + operatorId;
    }
    else {
        // If we don't filter for an operator, we show all public locations
        path += '?public=true';
    }
    return requestGet(base_url + path);
}

export const getLocationBySlug = (base_url, location_slug) => {
    return requestGet(base_url + '/api/public/v1/locations/by-slug/' + location_slug);
}

export const getLocationGeoJSONBySlug = (base_url, location_slug) => {
    return requestGet(base_url + '/api/public/v1/locations/by-slug/' + location_slug + '/geojson');
}


export const submitBooking = (data) => {
    return requestAdminAjaxPost(
        wc_add_to_cart_params.ajax_url,
        'obb_add_to_cart',
        data
    );
}


export const submitLocationNotify = (data) => {
    return requestAdminAjaxPost(
        wc_add_to_cart_params.ajax_url,
        'obb_add_location_free_notify',
        data
    );
}
